import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import LoginForMoreBenefits from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/LoginForMoreBenefits';
import useModalState from '@PROJECT_ROOT/assets/responsive-frontend/js/custom-hooks/useModalState';
import { USER_MENU_ID } from '@PROJECT_ROOT/assets/responsive-frontend/js/constants/modalIds';
import { BREAKPOINT_MD_PX } from '@PROJECT_ROOT/assets/responsive-frontend/js/constants/breakpoints';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    PROFILE_MENU_OPEN,
    PROFILE_MENU_LINK_SELECTED,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

function UserMenu() {
    const userMenuElement = useRef(document.getElementById(USER_MENU_ID));
    const userMenuContent = useRef(document.getElementById('userMenuContent'));
    const userMenuBtnDesktop = useRef(document.getElementById('userMenuBtnDesktop'));
    const userMenuCloseBtn = useRef(document.getElementById('userMenuCloseBtn'));
    const userMenuBackdrop = useRef(document.getElementById('userMenuBackdrop'));
    const mainHeader = useRef(document.getElementById('mainHeader'));
    const [isUserMenuOpen, setIsUserMenuOpen] = useModalState(USER_MENU_ID, BREAKPOINT_MD_PX);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const isInitialRender = useRef(true);

    useEffect(() => {
        userMenuElement.current.classList.remove('user-menu--display-none-initially');
        document.addEventListener('user-menu-mobile-btn-click', () => {
            setIsUserMenuOpen(!isUserMenuOpen);
        });
        userMenuBtnDesktop.current.addEventListener('click', () => {
            setIsUserMenuOpen(!isUserMenuOpen);
        });
        userMenuCloseBtn.current.addEventListener('click', () => {
            setIsUserMenuOpen(false);
        });
        userMenuBackdrop.current.addEventListener('click', () => {
            setIsUserMenuOpen(false);
        });
        document.addEventListener('click', (e) => {
            const isDesktopScreen = window.innerWidth >= BREAKPOINT_MD_PX;
            const isClickedOnUserMenuButton = userMenuBtnDesktop.current.contains(e.target);
            const isClickedInsideUserMenuContent = userMenuContent.current.contains(e.target);
            if (isDesktopScreen && !isClickedOnUserMenuButton && !isClickedInsideUserMenuContent) {
                setIsUserMenuOpen(false);
            }
        });
        const userLoginButton = document.getElementById('userLoginButton');
        userLoginButton?.addEventListener('click', () => {
            setIsLoginModalOpen(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        const isMobileScreen = window.innerWidth < BREAKPOINT_MD_PX;
        if (isUserMenuOpen) {
            if (isMobileScreen) {
                document.body.classList.add('modal-open');
                mainHeader.current.classList.remove('mobile-slide-down');
            }
            userMenuElement.current.classList.add('show');
            if (!IS_FRAME_SERVICE) dispatchTrackingEvent(PROFILE_MENU_OPEN);
        } else {
            document.body.classList.remove('modal-open');
            userMenuElement.current.classList.remove('show');
        }
    }, [isUserMenuOpen]);

    useEffect(() => {
        const userMenuItemsContainer = document.querySelector('.user-menu__items');
        const handleUserMenuItemClick = (event) => {
            const menuItem = event.target.closest('.user-menu__item');
            if (!menuItem) return;
            const trackingID = menuItem.dataset?.adriaticTracking;
            if (!trackingID) return;
            if (!IS_FRAME_SERVICE) {
                dispatchTrackingEvent(
                    PROFILE_MENU_LINK_SELECTED,
                    { link: trackingID },
                );
            }
        };
        userMenuItemsContainer?.addEventListener('click', handleUserMenuItemClick);
        userMenuItemsContainer?.addEventListener('auxclick', handleUserMenuItemClick);

        return () => {
            userMenuItemsContainer?.removeEventListener('click', handleUserMenuItemClick);
            userMenuItemsContainer?.removeEventListener('auxclick', handleUserMenuItemClick);
        };
    }, []);

    return <LoginForMoreBenefits isLoginModalOpenOutsideControl={isLoginModalOpen} onModalClose={() => setIsLoginModalOpen(false)} />;
}

export default function initUserMenu() {
    const userMenuElement = document.getElementById('userMenuReact');
    if (userMenuElement) {
        const root = createRoot(userMenuElement);
        root.render(<UserMenu />);
    }
}
